import { styled } from '@/stitches.config';
import { CSS } from '@stitches/react';

import { ReactComponent as Edit } from '@/assets/icons/edit.svg';
import { ReactComponent as CopyLink } from '@/assets/icons/copy-link.svg';

const RootContainer = styled('article', {
  backgroundColor: '$white',
  borderRadius: '$8',
  boxShadow: '$studyInsights$shadowBox',
  height: 'max-content',
  padding: '$6',
});

const Title = styled('h3', {
  fontSize: '$xl',
  fontWeight: '$bold',
  color: '$darkBlue300',
});

const HeaderContainer = styled('div', {
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: '$5',
  maxHeight: '$10',
});

const ControlsContainer = styled('div', {
  alignItems: 'center',
  cursor: 'pointer',
  display: 'flex',
  fontSize: '$normal',
  gap: '$12',
});

const IconButton = styled('button', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '50%',
  padding: '$1',
  '&:hover': {
    background: '$darkGray800',
  },
  border: 'none',
  background: 'transparent',
  cursor: 'pointer',
});

const EditIcon = styled(Edit, {
  color: '$darkGray400',
  height: '$6',
  width: '$6',
});

const CopyLinkIcon = styled(CopyLink, {
  color: '$darkGray400',
  height: '$6',
  width: '$6',
});

interface CampaignCardProps {
  children: React.ReactNode;
  header: {
    title?: string;
    css?: CSS;
  };
  card?: {
    css: CSS;
  };
  onEdit?: () => void;
  onCopy?: () => void;
}

export const CampaignCard = ({ children, header, card, onCopy, onEdit }: CampaignCardProps): JSX.Element => {
  return (
    <RootContainer css={card ? { ...card.css } : {}}>
      <HeaderContainer css={header.css ? { ...header.css } : {}}>
        <Title data-testid="campaign-name-value">{header.title ?? ''}</Title>
        <ControlsContainer>
          <IconButton onClick={onCopy}>
            <CopyLinkIcon />
          </IconButton>
          <IconButton onClick={onEdit}>
            <EditIcon />
          </IconButton>
        </ControlsContainer>
      </HeaderContainer>
      <div>{children}</div>
    </RootContainer>
  );
};
